// extracted by mini-css-extract-plugin
module.exports = {"templateBadgeElementList":"TemplateBadgeElementList_templateBadgeElementList__y30Md"};